<div *ngIf="loading" align="center" class="w-100">
	<br />
	<div class="loader"></div>
</div>
<div [hidden]="loading || !isUploadProducts">
	<h3 align="center">{{ progressBarTitle }}</h3>
	<app-progress-bar
		[data]="progressBarData"
		(onFinish)="finishUpload()"
		(onProgress)="startProgress()"
	></app-progress-bar>
</div>
@if(!loading && !isUploadProducts) {
<div
	class="page-wrapper"
	appScrollListener
	(scrolled)="onContainerScroll($event)"
	#scrollableContainer="appScrollListener"
>
	@if(toTopButtonVisible){
	<!--<button (click)="topFunction()" id="myBtn" title="Go to top"></button>-->
	<a class="scroll-up-button" (click)="scrollToTop(scrollableContainer)" aria-label="To top" title="Go to top">
		<i class="fa fa-arrow-up" aria-hidden="true"></i>
	</a>
	}

	<div class="top-section">
		<div class="control-input-container search-container">
			<div class="input-box">
				<input
					#name
					(input)="searchTrigger$.next()"
					[(ngModel)]="searchKeyword"
					type="text"
					class="form-control inputSearchByName"
					placeholder="{{ searchPlaceholder }}"
				/>
			</div>
		</div>

		<div class="button-list">
			<button class="btn btn-secondary" (click)="copyProducts()" [disabled]="countOfCheckedProducts === 0">
				{{ countOfCheckedProducts }} Import to
				<img class="ml-1" src="favicon.ico" />
			</button>
			<button
				class="btn btn-primary"
				(click)="print()"
				[disabled]="!isPrintingEnable"
				[ngbTooltip]="isPrintingEnableTitle"
				[openDelay]="300"
				[closeDelay]="300"
			>
				{{ countToPrint }} to print
			</button>
			<button class="btn btn-primary" (click)="copyUpdateProducts()">Import All</button>
			<button class="btn btn-secondary refresh-button" (click)="refresh()">
				<i class="mdi mdi-refresh"></i>
			</button>
		</div>

		<!-- <select *ngIf="!data.isFulfil" [(ngModel)]="isVisible" class="form-control cursorFinger col filterDropdown" (change)="getProducts(1)">
          <option value="">All</option>
          <option value="true">Visible</option>
          <option value="false">Hidden</option>
        </select> -->
	</div>
	<!-- <div *ngIf="data.isShopify && !data.UseBarcodeAsProductKey" class="modifyButton">
    <button class="btn btn-info copyAndRefreshButton simpleRfIdColor cursorFinger" (click)="confirmToModifyAll(true)" >
      <span *ngIf="countOfCheckedProductsSku === 0">Modify All {{productKey}}</span>
      <span *ngIf="countOfCheckedProductsSku > 0">Modify {{countOfCheckedProductsSku}} {{productKey}}</span>
    </button>
    <button class="btn btn-info copyAndRefreshButton simpleRfIdColor cursorFinger" (click)="confirmToModifyAll(false)" [disabled]="!CanRevert">
      Revert Modify {{productKey}}
    </button>
  </div> -->
	<div class="table-wrapper">
		<div class="table-scroller">
			<table>
				<thead>
					<tr>
						<th class="text-center col-expand-action"></th>
						<!-- <th class="text-center col-eye-action"></th> -->
						<th class="col-image"></th>
						<th class="col-name">Name</th>

						<!-- <th [hidden]="data.UseBarcodeAsProductKey" class="text-center"><input type="checkbox" class="cursorFinger"
							[(ngModel)]="allSelectedSku" (change)="selectAllSku()">
						</th> -->
						<th class="col-key">{{ productKey }}</th>
						<th class="text-right col-">Price</th>
						<th class="text-right">Quantity</th>
						<th class="imported-cell">Imported to</th>
						<th class="text-right">
							<div>
								<input type="checkbox" [(ngModel)]="allSelected" (change)="selectAll()" />
							</div>
						</th>
					</tr>
				</thead>
				<tbody>
					@for(product of products; track product; let i = $index){
					<tr [ngClass]="{ selected: iId.checked }">
						<td class="text-center row-action-wrapper">
							<input id="{{ product.Id }}" #iId (change)="(0)" type="checkbox" hidden />
							<label class="row-action expand-chevron" for="{{ product.Id }}">
								@if(product.Variants.length > 0){
								<i [ngClass]="iId.checked ? 'mdi mdi-chevron-down' : 'mdi mdi-chevron-right'"></i>
								}
							</label>
						</td>
						<!-- <td class="text-center row-action-wrapper">
							<input
								id="{{ product.Id }}_vis"
								[(ngModel)]="product.IsVisible"
								(change)="setVisibility(product)"
								type="checkbox"
								hidden
								disabled="{{ !product.IsVisibleActiv }}"
							/>
							<label
								class="row-action"
								[ngClass]="{ 'text-offline': !product.IsVisible }"
								for="{{ product.Id }}_vis"
							>
								<i
									[ngClass]="product.IsVisible ? 'mdi mdi-eye-outline' : 'mdi mdi-eye-off-outline'"
								></i>
							</label>
						</td> -->
						<td>
							<div class="table-img-box">
								<app-image-handler [product]="product"></app-image-handler>
							</div>
						</td>
						<td>{{ product.Name }}</td>
						<!-- <td scope="row" [hidden]="data.UseBarcodeAsProductKey"><input class="cursorFinger"
							*ngIf="product.Variants.length > 0 || product.Sku !== ''" type="checkbox"
							[(ngModel)] ="product.SelectedSku" (change)="selectAllSkuVariantsInProduct(product)" (click)="toggleSelectedSku(i, $event)">
							</td> -->
						<td
							[hidden]="data.UseBarcodeAsProductKey"
							*ngIf="product.Variants.length > 0 || product.Sku !== ''"
						>
							<a href="{{ getUrlToProduct(product.Id) }}" target="_blank">{{ product.Sku }}</a>
						</td>
						<td
							[hidden]="data.UseBarcodeAsProductKey"
							*ngIf="product.Sku === '' && product.Variants.length === 0"
						>
							<button
								class="btn btn-sm btn-info simpleRfIdColor cursorFinger"
								(click)="getUrl(product.Id)"
								href=""
							>
								Add {{ productKey }}
							</button>
						</td>
						<td
							[hidden]="!data.UseBarcodeAsProductKey"
							*ngIf="product.Variants.length > 0 || product.Barcode !== ''"
						>
							<a href="{{ getUrlToProduct(product.Id) }}" target="_blank">{{ product.Barcode }}</a>
						</td>
						<td
							[hidden]="!data.UseBarcodeAsProductKey"
							*ngIf="product.Barcode === '' && product.Variants.length === 0"
						>
							<button
								class="btn btn-sm btn-info simpleRfIdColor cursorFinger"
								(click)="getUrl(product.Id)"
								href=""
							>
								Add {{ productKey }}
							</button>
						</td>
						<td class="text-right">
							<div *ngIf="product.Price !== null">{{ product.Price }}</div>
						</td>
						<td
							class="text-right"
							[ngClass]="{ 'row-action-wrapper': !product.IsInventoryTrackingProduct }"
						>
							@if(product.IsInventoryTrackingProduct) {
							{{ product.Quantity }}
							} @else {
							<i
								class="row-action mdi mdi-map-marker-outline"
								(click)="setInventoryTracking(product)"
							></i>
							}
						</td>
						<td class="imported-cell text-center">
							<img *ngIf="productIsImported(product) && !product.Duplicate" src="favicon.ico" />
							<img
								*ngIf="product.Duplicate && data.isShopify"
								[title]="duplicateTitle"
								src="./assets/images/bol-failure.png"
							/>
						</td>
						<td class="text-center" scope="row">
							<input
								class="cursorFinger"
								*ngIf="product.Variants.length > 0 || product.Sku !== ''"
								type="checkbox"
								(click)="toggleSelected(i, $event)"
								[hidden]="product.Duplicate && data.isShopify"
								[(ngModel)]="product.Selected"
								(change)="selectAllVariantsInProduct(product)"
							/>
						</td>
					</tr>
					<tr *ngIf="iId.checked" class="no-hover">
						<td colspan="1000">
							<div class="row-expand">
								<table>
									<thead>
										<tr>
											<!-- <th [ngClass]="{'childColor' : iId.checked}"></th> -->
											<th class="col-image"></th>
											<th>Name</th>
											<th>Variants</th>
											<th>{{ productKey }}</th>
											<th class="text-right">Price</th>
											<th class="text-right">Quantity</th>
											<th class="imported-cell">Imported to</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let variant of product.Variants">
											<td>
												<div class="table-img-box">
													<app-image-handler [product]="variant"></app-image-handler>
												</div>
											</td>
											<td>{{ product.Name }}</td>
											<td>{{ variant.Properties }}</td>
											<td [hidden]="data.UseBarcodeAsProductKey" *ngIf="variant.Sku !== ''">
												<a href="{{ getUrlToProduct(product.Id) }}" target="_blank">{{
													variant.Sku
												}}</a>
											</td>
											<td [hidden]="data.UseBarcodeAsProductKey" *ngIf="variant.Sku === ''">
												<button
													class="btn btn-sm btn-info simpleRfIdColor"
													(click)="getUrl(product.Id)"
													href=""
												>
													Add {{ productKey }}
												</button>
											</td>
											<td [hidden]="!data.UseBarcodeAsProductKey" *ngIf="variant.Barcode !== ''">
												<a href="{{ getUrlToProduct(product.Id) }}" target="_blank">{{
													variant.Barcode
												}}</a>
											</td>
											<td [hidden]="!data.UseBarcodeAsProductKey" *ngIf="variant.Barcode === ''">
												<button
													class="btn btn-sm btn-info simpleRfIdColor"
													(click)="getUrl(product.Id)"
													href=""
												>
													Add {{ productKey }}
												</button>
											</td>
											<!-- <td [hidden]="data.UseBarcodeAsProductKey" class="checked-sku"><input type="checkbox" [(ngModel)]="variant.SelectedSku"
											(change)="chekSelectedSkuVariantsInProduct(product)" *ngIf="variant.Sku !== ''">
												</td> -->
											<td class="text-right">{{ variant.Price }}</td>
											<td class="text-right" *ngIf="variant.IsInventoryTrackingVariant">
												{{ variant.Quantity }}
											</td>
											<td class="imported-cell text-center">
												<img
													*ngIf="variant.IsImported && !variant.Duplicate"
													src="favicon.ico"
												/>
												<img
													*ngIf="variant.Duplicate && data.isShopify"
													[title]="duplicateTitle"
													src="./assets/images/bol-failure.png"
												/>
											</td>
											<td class="text-right">
												@if(!variant.IsInventoryTrackingVariant){
												<i
													class="row-action mdi mdi-map-marker-outline"
													(click)="setInventoryTracking(product, variant.Id)"
												></i>
												}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</td>
					</tr>
					}
				</tbody>
			</table>
		</div>
	</div>
</div>
} @if(!viewSmallPager) {
<div class="w-100 pager-container">
	<nav>
		<ul class="pagination" *ngIf="pager.pages && pager.pages.length" class="pagination justify-content-center">
			<li class="page-item cursorFinger" [ngClass]="{ disabled: pager.currentPage === 1 }">
				<a class="page-link cursorFinger" (click)="getProducts(1)">First</a>
			</li>
			<li class="page-item cursorFinger" [ngClass]="{ disabled: pager.currentPage === 1 }">
				<a class="page-link colorGray" (click)="getProducts(pager.currentPage - 1)"
					><span class="fa fa-angle-left"></span
				></a>
			</li>
			<li *ngFor="let page of pager.pages" class="page-item" [ngClass]="{ active: pager.currentPage === page }">
				<a class="page-link cursorFinger" (click)="getProducts(page)">{{ page }}</a>
			</li>
			<li class="page-item cursorFinger" [ngClass]="{ disabled: pager.currentPage === pager.totalPages }">
				<a class="page-link colorGray" (click)="getProducts(pager.currentPage + 1)"
					><span class="fa fa-angle-right"></span
				></a>
			</li>
			<li class="page-item cursorFinger" [ngClass]="{ disabled: pager.currentPage === pager.totalPages }">
				<a class="page-link" (click)="getProducts(pager.totalPages)">Last</a>
			</li>
		</ul>
	</nav>
</div>
} @else if(viewSmallPager) {
<div class="w-100 pager-container">
	<nav>
		<ul class="pagination justify-content-center">
			<li class="page-item cursorFinger" [ngClass]="{ disabled: fulfilPage === 1 }">
				<a class="page-link colorGray" (click)="getProducts(fulfilPage - 1)"
					><span class="fa fa-angle-left"></span
				></a>
			</li>
			<li class="page-item">
				<a class="page-link">{{ fulfilPage }}</a>
			</li>
			<li class="page-item cursorFinger" [ngClass]="{ disabled: pageButtonBlock }">
				<a class="page-link colorGray" (click)="getProducts(fulfilPage + 1)"
					><span class="fa fa-angle-right"></span
				></a>
			</li>
		</ul>
	</nav>
</div>
}
